<app-fire-foresight-menu></app-fire-foresight-menu>

<!-- BEGIN #content -->
<div id="content" class="app-content">
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Fire Foresight</a>
        </li>
        <li class="breadcrumb-item" *ngIf="fire && fire.camera">
          <a>Camera</a>
        </li>
        <li class="breadcrumb-item" *ngIf="fire && fire.camera">
          <a>{{fire.camera.name}}</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
  
    <div class="row mt-2">
      <div class="col-lg-8 col-sm-12">
        <div class="mb-4" *ngIf="fire.camera?.weatherStation">
          <div class="card-body">
            <div class="weather-desktop d-none d-lg-block">
              <div class="weather-desktop-row" *ngIf="fire.camera.weatherStation.data">
                <div class="weather-desktop-station">
                  <small>{{fire.camera.weatherStation.siteDescription ?? fire.camera.weatherStation.siteName}}</small>
                </div>
                <div class="weather-desktop-item">
                  <i class="bi bi-thermometer-sun"></i>
                  <div class="weather-desktop-value">{{fire.camera.weatherStation.data.AirTemperature?.value | number:'1.1-1' ?? "--"}}°C</div>
                </div>
                <div class="weather-desktop-item">
                  <i class="bi bi-droplet"></i>
                  <div class="weather-desktop-value">{{fire.camera.weatherStation.data.RelativeHumidity?.value | number:'1.0-0' ?? "--"}}%</div>
                </div>
                <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.WindSpeed?.value">
                  <div class="weather-desktop-item-icon">
                    <svg style="transform:rotate({{fire.camera.weatherStation.data.WindSpeed?.value}}deg);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                    </svg>
                  </div>
                  <div class="weather-desktop-value">{{fire.camera.weatherStation.data.WindSpeed?.value | number:'1.1-1' ?? "-"}} m/s</div>
                </div>
                <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.CummulativeRainfall?.value">
                  <i class="bi bi-cloud-rain"></i>
                  <div class="weather-desktop-value">{{fire.camera.weatherStation.data.CummulativeRainfall?.value ?? '--'}} mm</div>
                </div>
                <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.AirPressure?.value">
                  <i class="bi bi-speedometer"></i>
                  <div class="weather-desktop-value">{{fire.camera.weatherStation.data.AirPressure?.value | number:'1.0-0' ?? "----"}} hpa</div>
                </div>
              </div>
              <div class="weather-desktop-no-data" *ngIf="!fire.camera.weatherStation.data">
                <i class="bi bi-cloud-slash text-muted"></i>
                <div class="text-muted">No weather data in range</div>
              </div>
            </div>

            <div class="weather-mobile d-lg-none" *ngIf="fire.camera?.weatherStation?.data">
              <div class="weather-mobile-header" (click)="weatherMobileExpanded = !weatherMobileExpanded">
                <small>{{fire.camera.weatherStation.siteDescription ?? fire.camera.weatherStation.siteName}}</small>
                <i class="bi" [ngClass]="{'bi-chevron-down': !weatherMobileExpanded, 'bi-chevron-up': weatherMobileExpanded}"></i>
              </div>
              <div class="weather-mobile-grid" *ngIf="weatherMobileExpanded">
                <div class="weather-mobile-item">
                  <i class="bi bi-thermometer-sun"></i>
                  <div class="weather-mobile-value">{{fire.camera.weatherStation.data.AirTemperature?.value | number:'1.1-1' ?? "--"}}°C</div>
                </div>
                <div class="weather-mobile-item">
                  <i class="bi bi-droplet"></i>
                  <div class="weather-mobile-value">{{fire.camera.weatherStation.data.RelativeHumidity?.value | number:'1.0-0' ?? "--"}}%</div>
                </div>
                <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.WindSpeed?.value">
                  <svg style="transform:rotate({{fire.camera.weatherStation.data.WindSpeed?.value}}deg);" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" class="bi bi-arrow-up" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0-.708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                  </svg>
                  <div class="weather-mobile-value">{{fire.camera.weatherStation.data.WindSpeed?.value | number:'1.1-1' ?? "-"}} m/s</div>
                </div>
                <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.CummulativeRainfall?.value">
                  <i class="bi bi-cloud-rain"></i>
                  <div class="weather-mobile-value">{{fire.camera.weatherStation.data.CummulativeRainfall?.value ?? '--'}} mm</div>
                </div>
                <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.AirPressure?.value">
                  <i class="bi bi-speedometer"></i>
                  <div class="weather-mobile-value">{{fire.camera.weatherStation.data.AirPressure?.value | number:'1.0-0' ?? "----"}} hpa</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-4" [ngClass]="{'card-expand':expandImage}">
          <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            <span class="flex-grow-1">Latest Imagery : {{fire.camera?.name}}</span>
            <a (click)="setDayTimeImage()" title="Set as daytime image" class="btn btn-sm btn-outline-default mr"><i class="bi bi-sun"></i></a>
            <a (click)="setAllDayTimeImage()" title="Set all images as daytime image" class="btn btn-sm btn-outline-default mr"><i class="bi bi-sun"></i><i class="bi bi-plus"></i></a>
            <a (click)="changeMode(0);toggleZones()" [ngClass]="{'btn-outline-default':!showZones,'btn-default':showZones}" title="Show Ignore Zones" class="btn btn-sm mr"><i class="bi bi-ban"></i></a>
            <a (click)="changeMode(3)" [ngClass]="{'btn-outline-danger':mode == 3,'btn-danger':mode != 3}" title="Manual Fire Detection" class="btn btn-sm mr"><i class="bi bi-fire"></i></a>

            <a [routerLink]="'/fire-foresight/landscape/' + fire.camera?.siteId" class="text-inverse text-opacity-50 text-decoration-none btn mr" title="Landscape Mode"><i class="bi bi-headset-vr"></i></a>          
            <a (click)="changeMode(2)" data-toggle="card-expand" style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none cursor mr" *ngIf="this.fire.camera?.canStream">
              <i class="bi" [ngClass]="{'bi-camera-video':mode != 2,'bi-camera-video-fill':mode == 2}"></i>
            </a>
            
            <a (click)="expandImage = !expandImage" class="text-inverse text-opacity-50 text-decoration-none btn"><i class="bi bi-fullscreen"></i></a>
          </div>
          <div class="card-body p-0">
            <app-fire-camera-viewer [hidden]="mode != 0" #viewer 
              [showZones]="showZones" 
              [zones]="zones"
              (onImageChange)="bearingChanged($event)" 
              (onBearingChange)="displayDirection($event)"
              [siteTwin]="this.fire.twin" 
              [fullScreen]="true" 
              (onImageChange)="imageChange($event)" >
            </app-fire-camera-viewer>
            
            <fire-image-classifier *ngIf="mode == 3" [siteTwin]="fire.camera.twin" [selectedImage]="selectedImage" (onClosed)="changeMode(0);this.showFireDetection = false"></fire-image-classifier>        

            <div *ngIf="mode == 2" class="ratio ratio-16x9 animate__animated animate__fadeIn">
              <div class="overlay" *ngIf="streamUrl">
                <app-camera-controller #ptz [siteUri]="this.fire.camera?.siteUri" [simple]="!liveExpand" 
                  [ptzDirection]="ptzBearing" [ptzElevation]="ptzElevation" [ptzZoom]="ptzZoom" 
                  (ptzDirectionChanged)="ptzBearing = $event; timeout = 0;" (ptzElevationChanged)="ptzElevation = $event; timeout = 0;" (ptzZoomChanged)="ptzZoom = $event; timeout = 0;"></app-camera-controller>
              </div>
              
              <img *ngIf="mode == 2 && liveStreaming && streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="streamUrl" alt="Axis Camera Stream">
              <img *ngIf="mode == 2 && liveStreaming && !streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="'/assets/images/connecting.png'" alt="Axis Camera Stream">
            </div>

          </div>
        </div>

        
      </div>


      <div class="col-lg-4 col-sm-12">
        <div class="card mb-4" [ngClass]="{'card-expand':mapExpand}">
          <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            <span class="flex-grow-1">Map</span>
            
            <a (click)="toggleLayers()" data-toggle="card-expand" style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none mr">
              <i [ngClass]="{'bi-layers':!layersSelected,'bi-layers-fill':layersSelected}" class="bi"></i>
            </a>

            <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor" title="Expand image" (click)="mapExpand = !mapExpand;resizeMap()">
              <i class="bi bi-fullscreen"></i>
            </a>            
          </div>
          <div class="card-body p-0">
            <app-map #map [mapType]="'googleSat'" [mapheight]="mapHeight"></app-map>
          </div>
        </div>
      </div>
    </div>
  
    
  </div>
</div>
<!-- END #content -->
